import { render, staticRenderFns } from "./RemittanceCurrency.vue?vue&type=template&id=7a46a95e&scoped=true&"
import script from "./RemittanceCurrency.vue?vue&type=script&lang=js&"
export * from "./RemittanceCurrency.vue?vue&type=script&lang=js&"
import style0 from "./RemittanceCurrency.vue?vue&type=style&index=0&id=7a46a95e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a46a95e",
  null
  
)

export default component.exports